/**
 * Resultado de um envio ao /Queue, no formato da regra da DLQ (SyncQueue.js):
 * `{ok: true, kind: 'ok'}` | `{ok: false, kind: 'refused', status}` (o servidor recusou o
 * conteúdo) | `{ok: false, kind: 'transient', status?}` (servidor fora, rede/CORS, timeout,
 * circuito aberto, token sem renovação, limite de taxa).
 */

// 4xx que não são recusa do conteúdo: o mesmo envio pode passar depois.
export const TRANSIENT_4XX = [401, 408, 425, 429]

export const SEND_TRANSIENT = Object.freeze({
  ok: false,
  kind: 'transient',
  status: null,
})

/** Classifica a resposta HTTP (sem resposta = rede/CORS/timeout → transitório). */
export function sendOutcomeFromStatus(status) {
  if (typeof status !== 'number') return SEND_TRANSIENT
  if (status >= 200 && status <= 299) return { ok: true, kind: 'ok', status }
  const refused =
    status >= 400 && status < 500 && !TRANSIENT_4XX.includes(status)
  return { ok: false, kind: refused ? 'refused' : 'transient', status }
}

/**
 * Aceita o resultado detalhado ou o booleano do `sendData` (caminho legado e mocks):
 * `true` = ok; qualquer outra coisa = transitório.
 */
export function normalizeSend(r) {
  if (r && typeof r === 'object') {
    return {
      ok: !!r.ok,
      kind: r.kind ?? (r.ok ? 'ok' : 'transient'),
      status: r.status ?? null,
    }
  }
  return r === true ? { ok: true, kind: 'ok', status: null } : SEND_TRANSIENT
}
